export default __webpack_public_path__ + "static/media/background.ebcb9160.svg";